export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/education_training.d5adc2f.svg";